#import "../../../common/graphql/SecureRowLevelsEntityFields.graphql"
query ApprovalSetupCommonData {
  invoiceStatusTypes {
    nodes {
      id
      statusType
    }
  }
  approvalTypes(orderBy: APPROVAL_TYPE_ASC) {
    nodes {
      id
      approvalType
    }
  }
  companyCurrencies(orderBy: ISO_CODE_ASC) {
    nodes {
      id
      isoCode
      name
    }
  }
  userRankTypes(orderBy: SORT_ORDER_ASC) {
    nodes {
      id
      userRank
      sortOrder
    }
  }
  userOccupationTitles(orderBy: [SORT_ORDER_ASC, USER_OCCUPATION_TITLE_ASC]) {
    nodes {
      id
      userOccupationTitle
      sortOrder
    }
  }
  users(orderBy: NAME_ASC) {
    nodes {
      id
      name
      emailAccount
    }
  }
  companies(orderBy: NAME_ASC) {
    nodes {
      id
      name
    }
  }
  businessUnits(orderBy: NAME_ASC) {
    nodes {
      id
      name 
    }
  }
  purchaseOrderTypes(orderBy: PURCHASE_ORDER_TYPE_ASC) {
    nodes {
      id
      purchaseOrderType
    }
  }
  approvalPhases {
    nodes {
      id
      phaseName
    }
  }
  departments(
    orderBy: NAME_ASC
    filter: { _isSystemInternal: { notEqualTo: true } }
  ) {
    nodes {
      id
      name
    }
  }
  tags(
    orderBy: BADGE_NAME_ASC
    filter: {
      _isSystemGenerated: { notEqualTo: true }
      isPrivate: { notEqualTo: true }
    }
  ) {
    nodes {
      id
      badgeName
    }
  }
  departmentTypes(orderBy: DEPARTMENT_TYPE_ASC) {
    nodes {
      id
      departmentType
    }
  }
  departmentGroups {
    nodes {
      id
      name
    }
  }
  secureRowLevels(orderBy: NAME_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
  exchangeRateTypes(orderBy: ID_ASC) {
    nodes {
      id
      phaseName
    }
  }
   approverDelayTypes(orderBy: ID_ASC, filter: {_isDelayRule: {equalTo: true}}) {
    nodes {
      id
      delayType
      _isDelayRule
    }
  }
  approverTransactionTypes(orderBy: APPROVAL_TRANSACTION_TYPE_ASC) {
    nodes {
      id
      approvalTransactionType
    }
  }
  userDistributionLists(
    orderBy: USER_NAME_ASC
    filter: {isContactGroup: {equalTo: true}, userId: {isNull: false}}
  ) {
    nodes {
      userId
      userName
      userOccupation
    }
  }

}
